/*
 * @Author: your name
 * @Date: 2021-03-09 09:34:53
 * @LastEditTime: 2021-06-23 15:01:31
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \e6-module-settle-accounts-center\src\e6-module-settle-accounts-center\api\driverSubsidy.js
 */
import http from "e6-base-core/axios/config";

import { e6ModuleSettleAccountsCenterApi } from "@/config/api";
const { host, E6_MS_TMS_FINANCIAL_WEB } = e6ModuleSettleAccountsCenterApi;

// const mockURL = "/mock/5f27a2353d490a0020085574/privite";
// ------------------------ 司机津贴 ------------------------

// 新增司机津贴
export function saveAllowance(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/allowance/saveAllowance`,
    method: "post",
    data
  });
}

// 修改司机津贴
export function updateAllowance(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/allowance/updateAllowance`,
    method: "post",
    data
  });
}

// 详情司机津贴
export function getAllowanceById(params) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/allowance/getAllowanceById`,
    method: "get",
    params
  });
}

// 修改详情司机津贴
export function editAllowanceInfo(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/allowance/editAllowanceInfo`,
    method: "post",
    data
  });
}

// 获取司机津贴列表
export function listAllowanceByPage(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/allowance/listAllowanceByPage`,
    method: "post",
    data
  });
}

// 获取司机津贴更改历史列表
export function listAllowanceHistoryByPage(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/allowance/listAllowanceHistoryByPage`,
    method: "post",
    data
  });
}

// 津贴规则编码的校验
export function checkAllowanceCode(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/allowance/checkAllowanceCode`,
    method: "post",
    data
  });
}

// 津贴规则名称的校验
export function checkAllowanceName(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/allowance/checkAllowanceName`,
    method: "post",
    data
  });
}

// 删除司机津贴列表
export function deleteAllowances(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/allowance/deleteAllowances`,
    method: "post",
    data
  });
}
//津贴类型为货物数量时获取计费依据
export function fetchFeeStandardList(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/feeStandard/dropBox`,
    method: "post",
    data
  });
}

//津贴类型下拉数据（罗牛山司机津贴修改）
export function fetchAllowanceTypeData(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/allowanceInfo/ruleDropBox`,
    method: "post",
    data
  });
}
//津贴条件下拉
export function fetchSubsidyConditionData(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/allowanceInfo/conditionDropBox`,
    method: "post",
    data
  });
}

//获取司机津贴、送货员津贴编码
export function fetchSubsidyCode(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/allowanceInfo/initCode`,
    method: "post",
    data
  });
}
//保存司机津贴、送货员津贴新增、修改
export function saveSubsidyEdit(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/allowanceInfo/saveOrUpdate`,
    method: "post",
    data
  });
}
//获取司机津贴/送货员津贴详情（新）
export function fetchSubsidyDetail(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/allowanceInfo/findById`,
    method: "post",
    data
  });
}
//获取详情页自定义弹框数据
export function fetchDetailFee(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/allowanceInfo/findFeeById`,
    method: "post",
    data
  });
}
//删除司机津贴、送货员津贴（新）
export function deleteSubsidy(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/allowanceInfo/deleteByIds`,
    method: "post",
    data
  });
}
//获取表头
export function fetchPersonalSettingColumn(params) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/allowanceInfo/getColumn`,
    method: "get",
    params
  });
}
